module.exports = __webpack_public_path__ + "static/media/cart.99d2fca4.svg";